import { useTranslation } from 'next-i18next';
import { FilterType, freeFormHubFilterKeys } from '../../types';
import { FilterWrapper } from '../filterWrapper/filterWrapper';
import { useFreeFormHubInputValidator } from '../../hooks/inputValidator';
import { useFreeFormHubFilterState } from '../../hooks/useUrlFilterState';

export const ElectricalSection = () => {
  const { t } = useTranslation(['category/productFilter', 'common']);

  const checkboxValidator = useFreeFormHubInputValidator(FilterType.CHECKBOX);
  const [value, setValue] = useFreeFormHubFilterState<FilterType.CHECKBOX>(
    freeFormHubFilterKeys.ELECTRICALLY_CONDUCTIVE,
    checkboxValidator
  );

  return (
    <div className="mt-8">
      <FilterWrapper
        type={FilterType.CHECKBOX}
        props={{
          disabled: false,
          key: freeFormHubFilterKeys.ELECTRICALLY_CONDUCTIVE,
          id: freeFormHubFilterKeys.ELECTRICALLY_CONDUCTIVE,
          label: t(`FILTERS.LABELS.ELECTRICALLY_CONDUCTIVE`, { ns: 'free-form-hub/freeFormHub' }),
          value: value ?? false,
          onChange: newValue => {
            setValue(newValue === true ? true : undefined);
          },
        }}
      />
    </div>
  );
};
